import { render, staticRenderFns } from "./TrailerService.vue?vue&type=template&id=f8bc61d2"
import script from "./TrailerService.vue?vue&type=script&lang=js"
export * from "./TrailerService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports